
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/supplier",
      function () {
        return require("private-next-pages/supplier/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/supplier"])
      });
    }
  